<!--
Author: Yu
Create Time: 2019年9月18日17:29:34
Description: 货币输入框v4.0
-->
<template>
    <div :class="['el-input el-input--small',{'is-disabled': inputDisabled}]"
        @mouseenter="hovering = true"
        @mouseleave="hovering = false">
        <input class="el-input__inner" 
        v-bind:value="formatValue" 
        @input="updatevalue($event.target.value)" 
        ref="input" 
        @blur="onBlur" 
        @focus="selectAll"
        :disabled="inputDisabled"
        :readonly="readonly"
        @change="handleChange"/>
        <span class="el-input__suffix" v-if="getSuffixVisible()">
            <span class="el-input__suffix-inner">
                <i v-if="showClear" class="el-input__icon el-icon-circle-close el-input__clear" @mousedown.prevent @click="clear"></i>
            </span>
        </span>
    </div>
</template>

<script>
import accounting from "accounting"; // 数字格式
export default {
  name: "currencyInput",
  data() {
    return {
      hovering: false,
      focused: false
    };
  },
  inject: {
    elForm: {
      default: ""
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: () => 0,
      desc: "数值"
    },
    symbol: {
      type: String,
      default: () => "",
      desc: "货币标识符"
    },
    decimal: {
      type: Number,
      default: () => 2,
      desc: "小数位"
    },
    elvalue: [String, Number],
    disabled: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    formatValue() {
      if (this.focused) {
        if (this.value == "-") {
          return this.value;
        }
        return this.value ? accounting.unformat(this.value) : "";
      } else {
        if (this.value === 0) {
          return accounting.formatMoney(this.value, this.symbol, this.decimal);
        } else if (
          this.value === "" ||
          this.value === null ||
          this.value === undefined
        ) {
          return "";
        } else {
          return accounting.formatMoney(this.value, this.symbol, this.decimal);
        }
      }
    },
    inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    showClear() {
      return (
        this.clearable &&
        !this.inputDisabled &&
        !this.readonly &&
        this.value != "" &&
        this.hovering
      );
    }
  },
  watch: {},
  methods: {
    updatevalue(value) {
      if (value === "-") {
        return this.$emit("input", value);
      }
      var formatvalue = !!value ? accounting.unformat(value) : "";
      // 限制转换为两位小数
      // formatvalue = (formatvalue * 100) / 100;
      this.$emit("input", formatvalue);
    },
    onBlur() {
      if (this.readonly) {
        return;
      }
      this.focused = false;
      this.$emit("blur", event);
      this.dispatch("ElFormItem", "el.form.blur", [this.value]);
    },
    selectAll(event) {
      if (this.readonly) {
        return;
      }
      this.focused = true;
      setTimeout(() => {
        event.target.select();
      }, 0);
      this.$emit("focus", event);
    },

    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    getSuffixVisible() {
      return this.showClear;
    },
    clear() {
      this.$emit("input", "");
      this.$emit("change", "");
      this.$emit("clear");
    },
    handleChange(event) {
      this.$emit("change", event.target.value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/input/currencyInput.vue